import type { NarrativeItem } from "@/types/quest";
import { NarrativeDirection } from "@/types/quest";
import { Avatars } from "@/types/ui";
import { BackgroundImage, QuestNarrativeTypes } from "./narrative_type";

export const narrativesSide = new Map<number, NarrativeItem>([
	// Rupert's search
	[
		500101,
		{
			quest_id: 5001,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_3,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.5001.narrative_1",
			},
		},
	],
	[
		500102,
		{
			quest_id: 5001,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_3,
				character_name: "{username}",
				text: "quest.5001.narrative_2",
			},
		},
	],
	[
		500103,
		{
			quest_id: 5001,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_3,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.5001.narrative_3",
			},
		},
	],
	[
		500104,
		{
			quest_id: 5001,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_3,
				character_name: "{username}",
				text: "quest.5001.narrative_4",
			},
		},
	],
	[
		500105,
		{
			quest_id: 5001,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_3,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.5001.narrative_5",
			},
		},
	],
	[
		500106,
		{
			quest_id: 5001,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_3,
				character_name: "{username}",
				text: "quest.5001.narrative_6",
			},
		},
	],
	[
		500107,
		{
			quest_id: 5001,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_3,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.5001.narrative_7",
			},
		},
	],
	[
		500201,
		{
			quest_id: 5002,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_4,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.5002.narrative_1",
			},
		},
	],
	[
		500202,
		{
			quest_id: 5002,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_4,
				character_name: "{username}",
				text: "quest.5002.narrative_2",
			},
		},
	],
	[
		500203,
		{
			quest_id: 5002,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_4,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.5002.narrative_3",
			},
		},
	],
	[
		500204,
		{
			quest_id: 5002,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_4,
				character_name: "{username}",
				text: "quest.5002.narrative_4",
			},
		},
	],
	[
		500205,
		{
			quest_id: 5002,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_4,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.5002.narrative_5",
			},
		},
	],
	[
		500301,
		{
			quest_id: 5003,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_5,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.5003.narrative_1",
			},
		},
	],
	[
		500302,
		{
			quest_id: 5003,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_5,
				character_name: "{username}",
				text: "quest.5003.narrative_2",
			},
		},
	],
	[
		500303,
		{
			quest_id: 5003,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_5,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.5003.narrative_3",
			},
		},
	],
	[
		500304,
		{
			quest_id: 5003,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_5,
				character_name: "{username}",
				text: "quest.5003.narrative_4",
			},
		},
	],
	[
		500401,
		{
			quest_id: 5004,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.5004.narrative_1",
			},
		},
	],
	[
		500402,
		{
			quest_id: 5004,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				character_name: "{username}",
				text: "quest.5004.narrative_2",
			},
		},
	],
	[
		500403,
		{
			quest_id: 5004,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.5004.narrative_3",
			},
		},
	],
	[
		500404,
		{
			quest_id: 5004,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.5004.narrative_4",
			},
		},
	],
	[
		500405,
		{
			quest_id: 5004,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.5004.narrative_5",
			},
		},
	],
	[
		500406,
		{
			quest_id: 5004,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.5004.narrative_6",
			},
		},
	],
	[
		500407,
		{
			quest_id: 5004,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				character_name: "{username}",
				text: "quest.5004.narrative_7",
			},
		},
	],
	[
		500501,
		{
			quest_id: 5005,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.5005.narrative_1",
			},
		},
	],
	[
		500502,
		{
			quest_id: 5005,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				character_name: "{username}",
				text: "quest.5005.narrative_2",
			},
		},
	],
	[
		500503,
		{
			quest_id: 5005,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.5005.narrative_3",
			},
		},
	],
	[
		500504,
		{
			quest_id: 5005,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				character_name: "{username}",
				text: "quest.5005.narrative_4",
			},
		},
	],
	[
		500505,
		{
			quest_id: 5005,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.5005.narrative_5",
			},
		},
	],
	[
		500506,
		{
			quest_id: 5005,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.5005.narrative_6",
			},
		},
	],
	[
		500507,
		{
			quest_id: 5005,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				character_name: "{username}",
				text: "quest.5005.narrative_7",
			},
		},
	],
	// Echoes of Pestilence
	[
		500601,
		{
			quest_id: 5006,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.5006.narrative_1",
			},
		},
	],
	[
		500602,
		{
			quest_id: 5006,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.5006.narrative_2",
			},
		},
	],
	[
		500603,
		{
			quest_id: 5006,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.5006.narrative_3",
			},
		},
	],
	[
		500604,
		{
			quest_id: 5006,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.VIVIANNE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.vivianne.non_translatable",
				text: "quest.5006.narrative_4",
			},
		},
	],
	[
		500605,
		{
			quest_id: 5006,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.VIVIANNE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.5006.narrative_5",
			},
		},
	],
	[
		500606,
		{
			quest_id: 5006,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.VIVIANNE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.vivianne.non_translatable",
				text: "quest.5006.narrative_6",
			},
		},
	],
	[
		500607,
		{
			quest_id: 5006,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.VIVIANNE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.5006.narrative_7",
			},
		},
	],
	[
		500608,
		{
			quest_id: 5006,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.VIVIANNE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.vivianne.non_translatable",
				text: "quest.5006.narrative_8",
			},
		},
	],
	[
		500609,
		{
			quest_id: 5006,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.VIVIANNE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.5006.narrative_9",
			},
		},
	],
	[
		500610,
		{
			quest_id: 5006,
			order_number: 10,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.VIVIANNE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.vivianne.non_translatable",
				text: "quest.5006.narrative_10",
			},
		},
	],
	[
		500611,
		{
			quest_id: 5006,
			order_number: 11,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.VIVIANNE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.5006.narrative_11",
			},
		},
	],
	[
		500701,
		{
			quest_id: 5007,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_PLAGUE_2,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.5007.narrative_1",
			},
		},
	],
	[
		500702,
		{
			quest_id: 5007,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.VIVIANNE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_PLAGUE_2,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.vivianne.non_translatable",
				text: "quest.5007.narrative_2",
			},
		},
	],
	[
		500703,
		{
			quest_id: 5007,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.VIVIANNE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_PLAGUE_2,
				character_name: "{username}",
				text: "quest.5007.narrative_3",
			},
		},
	],
	[
		500704,
		{
			quest_id: 5007,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.VIVIANNE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_PLAGUE_2,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.vivianne.non_translatable",
				text: "quest.5007.narrative_4",
			},
		},
	],
	[
		500705,
		{
			quest_id: 5007,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.VIVIANNE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_PLAGUE_2,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.vivianne.non_translatable",
				text: "quest.5007.narrative_5",
			},
		},
	],
	[
		500706,
		{
			quest_id: 5007,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.VIVIANNE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_PLAGUE_2,
				character_name: "{username}",
				text: "quest.5007.narrative_6",
			},
		},
	],
	[
		500801,
		{
			quest_id: 5008,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_2,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.5008.narrative_1",
			},
		},
	],
	[
		500802,
		{
			quest_id: 5008,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.VIVIANNE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_2,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.vivianne.non_translatable",
				text: "quest.5008.narrative_2",
			},
		},
	],
	[
		500803,
		{
			quest_id: 5008,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.VIVIANNE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_2,
				character_name: "{username}",
				text: "quest.5008.narrative_3",
			},
		},
	],
	[
		500804,
		{
			quest_id: 5008,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.VIVIANNE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_2,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.vivianne.non_translatable",
				text: "quest.5008.narrative_4",
			},
		},
	],
	[
		500805,
		{
			quest_id: 5008,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.VIVIANNE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_2,
				character_name: "{username}",
				text: "quest.5008.narrative_5",
			},
		},
	],
	[
		500806,
		{
			quest_id: 5008,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.VIVIANNE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_2,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.vivianne.non_translatable",
				text: "quest.5008.narrative_6",
			},
		},
	],
	[
		500807,
		{
			quest_id: 5008,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_2,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.5008.narrative_7",
			},
		},
	],
	[
		500808,
		{
			quest_id: 5008,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.VIVIANNE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_2,
				character_name: "{username}",
				text: "quest.5008.narrative_8",
			},
		},
	],
	[
		500809,
		{
			quest_id: 5008,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.VIVIANNE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_2,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.vivianne.non_translatable",
				text: "quest.5008.narrative_9",
			},
		},
	],
	[
		500901,
		{
			quest_id: 5009,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_8,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.5009.narrative_1",
			},
		},
	],
	[
		500902,
		{
			quest_id: 5009,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.VIVIANNE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_8,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.vivianne.non_translatable",
				text: "quest.5009.narrative_2",
			},
		},
	],
	[
		500903,
		{
			quest_id: 5009,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.VIVIANNE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_8,
				character_name: "{username}",
				text: "quest.5009.narrative_3",
			},
		},
	],
	[
		500904,
		{
			quest_id: 5009,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.VIVIANNE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_8,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.vivianne.non_translatable",
				text: "quest.5009.narrative_4",
			},
		},
	],
	[
		500905,
		{
			quest_id: 5009,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.VIVIANNE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_8,
				character_name: "{username}",
				text: "quest.5009.narrative_5",
			},
		},
	],
	[
		501001,
		{
			quest_id: 5010,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_PLAGUE_7,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.5010.narrative_1",
			},
		},
	],
	[
		501002,
		{
			quest_id: 5010,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_PLAGUE_7,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.5010.narrative_2",
			},
		},
	],
	[
		501003,
		{
			quest_id: 5010,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_PLAGUE_7,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.5010.narrative_3",
			},
		},
	],
	[
		501004,
		{
			quest_id: 5010,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_PLAGUE_7,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.5010.narrative_4",
			},
		},
	],
	[
		501005,
		{
			quest_id: 5010,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_PLAGUE_7,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.5010.narrative_5",
			},
		},
	],
	[
		501006,
		{
			quest_id: 5010,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_PLAGUE_7,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.5010.narrative_6",
			},
		},
	],
	[
		501007,
		{
			quest_id: 5010,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_PLAGUE_7,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.5010.narrative_7",
			},
		},
	],
	[
		501008,
		{
			quest_id: 5010,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.VIVIANNE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_PLAGUE_7,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.vivianne.non_translatable",
				text: "quest.5010.narrative_8",
			},
		},
	],
	[
		501009,
		{
			quest_id: 5010,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_PLAGUE_7,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.5010.narrative_9",
			},
		},
	],
	[
		501010,
		{
			quest_id: 5010,
			order_number: 10,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_PLAGUE_7,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.5010.narrative_10",
			},
		},
	],
	[
		501011,
		{
			quest_id: 5010,
			order_number: 11,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.VIVIANNE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_PLAGUE_7,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.vivianne.non_translatable",
				text: "quest.5010.narrative_11",
			},
		},
	],
	[
		501101,
		{
			quest_id: 5011,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_PLAGUE_7,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.5011.narrative_1",
			},
		},
	],
	[
		501102,
		{
			quest_id: 5011,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_PLAGUE_7,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.5011.narrative_2",
			},
		},
	],
	[
		501103,
		{
			quest_id: 5011,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_PLAGUE_7,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.5011.narrative_3",
			},
		},
	],
	[
		501104,
		{
			quest_id: 5011,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_PLAGUE_7,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.5011.narrative_4",
			},
		},
	],
	[
		501105,
		{
			quest_id: 5011,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_PLAGUE_7,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.5011.narrative_5",
			},
		},
	],
	[
		501106,
		{
			quest_id: 5011,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_PLAGUE_7,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.5011.narrative_6",
			},
		},
	],
	[
		501107,
		{
			quest_id: 5011,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_PLAGUE_7,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.5011.narrative_7",
			},
		},
	],
	[
		501108,
		{
			quest_id: 5011,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_PLAGUE_7,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.5011.narrative_8",
			},
		},
	],
	[
		501109,
		{
			quest_id: 5011,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_PLAGUE_7,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.5011.narrative_9",
			},
		},
	],
	[
		501110,
		{
			quest_id: 5011,
			order_number: 10,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_PLAGUE_7,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.5011.narrative_10",
			},
		},
	],
	[
		501111,
		{
			quest_id: 5011,
			order_number: 11,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_PLAGUE_7,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.5011.narrative_11",
			},
		},
	],
	[
		501112,
		{
			quest_id: 5011,
			order_number: 12,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_PLAGUE_7,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.5011.narrative_12",
			},
		},
	],
	[
		501113,
		{
			quest_id: 5011,
			order_number: 13,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.VIVIANNE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_PLAGUE_7,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.vivianne.non_translatable",
				text: "quest.5011.narrative_13",
			},
		},
	],
	[
		501114,
		{
			quest_id: 5011,
			order_number: 14,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.VIVIANNE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_PLAGUE_7,
				character_name: "{username}",
				text: "quest.5011.narrative_14",
			},
		},
	],
	// A Nice Day For Fishing
	[
		501201,
		{
			quest_id: 5012,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.5012.narrative_1",
			},
		},
	],
	[
		501202,
		{
			quest_id: 5012,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.5012.narrative_2",
			},
		},
	],
	[
		501203,
		{
			quest_id: 5012,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.5012.narrative_3",
			},
		},
	],
	[
		501204,
		{
			quest_id: 5012,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.5012.narrative_4",
			},
		},
	],
	[
		501205,
		{
			quest_id: 5012,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.5012.narrative_5",
			},
		},
	],
	[
		501206,
		{
			quest_id: 5012,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.5012.narrative_6",
			},
		},
	],
	[
		501301,
		{
			quest_id: 5013,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.5013.narrative_1",
			},
		},
	],
	[
		501302,
		{
			quest_id: 5013,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.5013.narrative_2",
			},
		},
	],
	[
		501303,
		{
			quest_id: 5013,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.5013.narrative_3",
			},
		},
	],
	[
		501304,
		{
			quest_id: 5013,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.5013.narrative_4",
			},
		},
	],
	[
		501305,
		{
			quest_id: 5013,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.5013.narrative_5",
			},
		},
	],
	[
		501401,
		{
			quest_id: 5014,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_27,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.5014.narrative_1",
			},
		},
	],
	[
		501402,
		{
			quest_id: 5014,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_27,
				character_name: "{username}",
				text: "quest.5014.narrative_2",
			},
		},
	],
	[
		501403,
		{
			quest_id: 5014,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_27,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.5014.narrative_3",
			},
		},
	],
	[
		501404,
		{
			quest_id: 5014,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_27,
				character_name: "{username}",
				text: "quest.5014.narrative_4",
			},
		},
	],
	[
		501405,
		{
			quest_id: 5014,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_27,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.5014.narrative_5",
			},
		},
	],
	[
		501501,
		{
			quest_id: 5015,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.5015.narrative_1",
			},
		},
	],
	[
		501502,
		{
			quest_id: 5015,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.5015.narrative_2",
			},
		},
	],
	[
		501503,
		{
			quest_id: 5015,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.5015.narrative_3",
			},
		},
	],
	[
		501601,
		{
			quest_id: 5016,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_27,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.5016.narrative_1",
			},
		},
	],
	[
		501602,
		{
			quest_id: 5016,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_27,
				character_name: "{username}",
				text: "quest.5016.narrative_2",
			},
		},
	],
	[
		501603,
		{
			quest_id: 5016,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_27,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.5016.narrative_3",
			},
		},
	],
	[
		501604,
		{
			quest_id: 5016,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_27,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.5016.narrative_4",
			},
		},
	],
	[
		501605,
		{
			quest_id: 5016,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_27,
				character_name: "{username}",
				text: "quest.5016.narrative_5",
			},
		},
	],
	[
		501606,
		{
			quest_id: 5016,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_27,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.5016.narrative_6",
			},
		},
	],
	// Iron Mines
	[
		501701,
		{
			quest_id: 5017,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_1,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.5017.narrative_1",
			},
		},
	],
	[
		501702,
		{
			quest_id: 5017,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.WALTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_1,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.walter.non_translatable",
				text: "quest.5017.narrative_2",
			},
		},
	],
	[
		501703,
		{
			quest_id: 5017,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_1,
				character_name: "{username}",
				text: "quest.5017.narrative_3",
			},
		},
	],
	[
		501801,
		{
			quest_id: 5018,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.WALTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_1,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.walter.non_translatable",
				text: "quest.5018.narrative_1",
			},
		},
	],
	[
		501802,
		{
			quest_id: 5018,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.WALTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_1,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.walter.non_translatable",
				text: "quest.5018.narrative_2",
			},
		},
	],
	[
		501901,
		{
			quest_id: 5019,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.WALTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_13,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.walter.non_translatable",
				text: "quest.5019.narrative_1",
			},
		},
	],
	[
		501902,
		{
			quest_id: 5019,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.WALTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_13,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.walter.non_translatable",
				text: "quest.5019.narrative_2",
			},
		},
	],
	[
		501903,
		{
			quest_id: 5019,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.WALTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_13,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.walter.non_translatable",
				text: "quest.5019.narrative_3",
			},
		},
	],
	[
		502001,
		{
			quest_id: 5020,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.WALTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_13,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.walter.non_translatable",
				text: "quest.5020.narrative_1",
			},
		},
	],
	[
		502002,
		{
			quest_id: 5020,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.WALTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_13,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.walter.non_translatable",
				text: "quest.5020.narrative_2",
			},
		},
	],
	[
		502003,
		{
			quest_id: 5020,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.WALTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_13,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.walter.non_translatable",
				text: "quest.5020.narrative_3",
			},
		},
	],
	[
		502004,
		{
			quest_id: 5020,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.WALTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_13,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.walter.non_translatable",
				text: "quest.5020.narrative_4",
			},
		},
	],
	[
		502101,
		{
			quest_id: 5021,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.5021.narrative_1",
			},
		},
	],
	[
		502102,
		{
			quest_id: 5021,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.5021.narrative_2",
			},
		},
	],
	[
		502103,
		{
			quest_id: 5021,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.5021.narrative_3",
			},
		},
	],
	[
		502104,
		{
			quest_id: 5021,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.5021.narrative_4",
			},
		},
	],
	[
		502105,
		{
			quest_id: 5021,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.5021.narrative_5",
			},
		},
	],
	[
		502106,
		{
			quest_id: 5021,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.5021.narrative_6",
			},
		},
	],
	[
		502107,
		{
			quest_id: 5021,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.5021.narrative_7",
			},
		},
	],
	[
		502108,
		{
			quest_id: 5021,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.5021.narrative_8",
			},
		},
	],
	[
		502109,
		{
			quest_id: 5021,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.5021.narrative_9",
			},
		},
	],
	[
		502201,
		{
			quest_id: 5022,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.5022.narrative_1",
			},
		},
	],
	[
		502202,
		{
			quest_id: 5022,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.5022.narrative_2",
			},
		},
	],
	[
		502203,
		{
			quest_id: 5022,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.5022.narrative_3",
			},
		},
	],
	[
		502204,
		{
			quest_id: 5022,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.5022.narrative_4",
			},
		},
	],
	[
		502301,
		{
			quest_id: 5023,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.5023.narrative_1",
			},
		},
	],
	[
		502302,
		{
			quest_id: 5023,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.5023.narrative_2",
			},
		},
	],
	[
		502303,
		{
			quest_id: 5023,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.5023.narrative_3",
			},
		},
	],
	[
		502304,
		{
			quest_id: 5023,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.5023.narrative_4",
			},
		},
	],
	[
		502401,
		{
			quest_id: 5024,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.5024.narrative_1",
			},
		},
	],
	[
		502402,
		{
			quest_id: 5024,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.5024.narrative_2",
			},
		},
	],
	[
		502403,
		{
			quest_id: 5024,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.5024.narrative_3",
			},
		},
	],
	[
		502404,
		{
			quest_id: 5024,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.5024.narrative_4",
			},
		},
	],
	[
		502405,
		{
			quest_id: 5024,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.5024.narrative_5",
			},
		},
	],
	[
		502406,
		{
			quest_id: 5024,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.5024.narrative_6",
			},
		},
	],
	[
		502407,
		{
			quest_id: 5024,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.5024.narrative_7",
			},
		},
	],
	[
		502501,
		{
			quest_id: 5025,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.5025.narrative_1",
			},
		},
	],
	[
		502502,
		{
			quest_id: 5025,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.5025.narrative_2",
			},
		},
	],
	[
		502503,
		{
			quest_id: 5025,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.5025.narrative_3",
			},
		},
	],
	[
		502504,
		{
			quest_id: 5025,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.5025.narrative_4",
			},
		},
	],
	[
		502601,
		{
			quest_id: 5026,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.5026.narrative_1",
			},
		},
	],
	[
		502602,
		{
			quest_id: 5026,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.5026.narrative_2",
			},
		},
	],
	[
		502603,
		{
			quest_id: 5026,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.5026.narrative_3",
			},
		},
	],
	[
		502701,
		{
			quest_id: 5027,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.5027.narrative_1",
			},
		},
	],
	[
		502702,
		{
			quest_id: 5027,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.5027.narrative_2",
			},
		},
	],
	[
		502703,
		{
			quest_id: 5027,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.5027.narrative_3",
			},
		},
	],
	[
		502704,
		{
			quest_id: 5027,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.5027.narrative_4",
			},
		},
	],
	[
		502705,
		{
			quest_id: 5027,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.5027.narrative_5",
			},
		},
	],
	[
		502706,
		{
			quest_id: 5027,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.5027.narrative_6",
			},
		},
	],
	[
		502707,
		{
			quest_id: 5027,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.5027.narrative_7",
			},
		},
	],
	[
		502801,
		{
			quest_id: 5028,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.5028.narrative_1",
			},
		},
	],
	[
		502802,
		{
			quest_id: 5028,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.5028.narrative_2",
			},
		},
	],
]);
